import { render, staticRenderFns } from "./MedicalCaseDetails.vue?vue&type=template&id=6a92d3a6&scoped=true"
import script from "./MedicalCaseDetails.vue?vue&type=script&lang=js"
export * from "./MedicalCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a92d3a6",
  null
  
)

export default component.exports